// Reusable StatusChip component with consistent case status styling
import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { getCaseStatusSx, getCaseStatusLabel, CaseStatus } from '../utils/caseStatusStyles';

interface StatusChipProps extends Omit<ChipProps, 'label'> {
  status: CaseStatus;
  /**
   * Override the default label if needed
   */
  customLabel?: string;
}

/**
 * StatusChip component that automatically applies consistent styling for case statuses
 */
export const StatusChip: React.FC<StatusChipProps> = ({
  status,
  customLabel,
  sx = {},
  ...chipProps
}) => {
  const statusSx = getCaseStatusSx(status);
  const label = getCaseStatusLabel(status);

  return (
    <Chip
      label={customLabel || label}
      sx={{
        fontWeight: 500,
        border: 'none',
        ...statusSx,
        ...(sx as any)
      }}
      {...chipProps}
    />
  );
};

export default StatusChip;